

(function ($) {
    $(function () {
        const nofollowInit = () => {
            $('a').each(function () {
                const url = new URL($(this).prop('href'));
                if (url.hostname.includes('nmbtc')) {
                    if (url.search !== "") {
                        $(this).attr('rel', 'nofollow');
                    }
                }
            });
        }
        const init = () => {
            console.log("nofollow-------------------js");
            nofollowInit()
        }

        init();
    });
})(jQuery, window, document);
